import type {
    LoginRequest,
    LogoutRequest,
    ResendPhoneOTPRequest,
    VerifyPhoneOTPRequest,
    WhoAmIApiRequest,
} from '@/types/api/auth';

type AuthApi = {
    login: LoginRequest['url'];
    whoAmI: WhoAmIApiRequest['url'];
    logout: LogoutRequest['url'];
    verifyPhoneOTP: VerifyPhoneOTPRequest['url'];
    resendPhoneOTP: ResendPhoneOTPRequest['url'];
};

export const authApi: AuthApi = {
    login: 'login',
    whoAmI: 'whoAmI',
    logout: 'logout',
    verifyPhoneOTP: 'login/verify-phone',
    resendPhoneOTP: 'resend-code',
};
